import { UIHoverActionController } from './UIHoverActionController.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { CardEnum, TileCornerBuildingType } from '@colonist/game-states';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
export class UIKnightActivationHoverActionController extends UIHoverActionController {
    onEvent(data, eventType) {
        super.onEvent(data, eventType);
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.KnightStateUpdated:
                this.updateState();
                break;
            default:
                break;
        }
    }
    updateState() {
        const action = this.knightPlayerValidator.canPlayerActivateKnight();
        this.updateHoverLocations(action.validHoverLocations, action.canTakeAction);
    }
    getTexture(locationCornerIndex) {
        const knightAtLocation = this.knightPlayerValidator.getKnightAtLocation(locationCornerIndex);
        if (knightAtLocation === undefined) return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, TileCornerBuildingType.KnightInactiveLevel1);
        const knightTexture = TileCornerBuildingType[`KnightActiveLevel${knightAtLocation.level}`];
        return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, knightTexture);
    }
    // eslint-disable-next-line class-methods-use-this
    getBankActionAmount(index) {
        return undefined;
    }
    constructor(uiGameManager, knightPlayerValidator){
        super(uiGameManager);
        this.isCornerAction = true;
        this.resources = [
            CardEnum.Grain
        ];
        this.action = (index)=>this.uiGameManager.socketGameSend.confirmActivateKnightSkippingSelection(index);
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this);
        this.knightPlayerValidator = knightPlayerValidator;
    }
}
